import React from "react";
import JobApplicationSummaryActions from "./JobApplicationSummaryActions";
import ProfileMatch from "./ProfileMatch";
import InterviewProgress from "./InterviewProgress";
import ApplicationInsightCard from "./ApplicationInsightCard";
import { JobApplication } from "../../../../Entities/JobApplication";
import { MatchResult } from "../../../../Entities/MatchResult";
import { JobDescriptionEntity } from "../../../../Entities/JobDescription";
import { UserProfile } from "../../../../Entities/UserProfile";
import { InterviewRound } from "../../../../Dto/GenerateJobDescription.dto";
import { Session } from "../../../../Entities/Session";
import "./JobApplicationSummary.scss";

interface JobApplicationSummaryProps {
  jobApplication: JobApplication;
  profileMatchResult: MatchResult | null;
  jobPost: JobDescriptionEntity;
  profile: UserProfile | null;
  interviewRounds: InterviewRound[];
  interviewSessions: Session[];
  setActiveTabKey: React.Dispatch<React.SetStateAction<string>>;
  setIsResumeViewing: React.Dispatch<
    React.SetStateAction<{
      isResumeViewing: boolean;
      resumeUrl: string | null;
    }>
  >;
  setSelectedSession: React.Dispatch<React.SetStateAction<Session | null>>;
  handleMoveToAIAssessmentRound: () => Promise<void>;
  handleRestartAIAssessmentRound: () => Promise<void>;
  handleMarkAsShortlisted: () => Promise<void>;
  handleMarkAsRejected: () => Promise<void>;
  handleMarkAsHired: () => Promise<void>;
  handleAllowInterviewSchedule: () => Promise<void>;
  handleSendReminderNotification: (
    type: "profile.match" | "round",
  ) => Promise<void>;
  setProfileMatchResult: React.Dispatch<
    React.SetStateAction<MatchResult | null>
  >;
  setSelectedApplication: React.Dispatch<
    React.SetStateAction<JobApplication | null>
  >;
  setUserProfile: React.Dispatch<React.SetStateAction<UserProfile | null>>;
}

const JobApplicationSummary: React.FC<JobApplicationSummaryProps> = ({
  jobApplication,
  profileMatchResult,
  jobPost,
  profile,
  interviewRounds,
  interviewSessions,
  setActiveTabKey,
  setIsResumeViewing,
  setSelectedSession,
  handleMoveToAIAssessmentRound,
  handleRestartAIAssessmentRound,
  handleMarkAsShortlisted,
  handleMarkAsRejected,
  handleMarkAsHired,
  handleAllowInterviewSchedule,
  handleSendReminderNotification,
  setProfileMatchResult,
  setSelectedApplication,
  setUserProfile,
}) => {
  return (
    <div className="job-application-summary-container">
      <JobApplicationSummaryActions
        jobPost={jobPost}
        jobApplication={jobApplication}
        interviewSessions={interviewSessions}
        handleMoveToAIAssessmentRound={handleMoveToAIAssessmentRound}
        handleRestartAIAssessmentRound={handleRestartAIAssessmentRound}
        handleMarkAsShortlisted={handleMarkAsShortlisted}
        handleMarkAsRejected={handleMarkAsRejected}
        handleMarkAsHired={handleMarkAsHired}
        handleAllowInterviewSchedule={handleAllowInterviewSchedule}
        interviewRounds={interviewRounds}
        setActiveTabKey={setActiveTabKey}
        profileMatchResult={profileMatchResult}
      />
      <ApplicationInsightCard
        jobApplicationId={jobApplication._id}
        jobApplication={jobApplication}
      />
      <div className="job-application-summary-content-wrapper">
        {/* <Overview jobApplication={jobApplication} /> */}
        <ProfileMatch
          jobApplication={jobApplication}
          profileMatchResult={profileMatchResult}
          jobPost={jobPost}
          profile={profile}
          setActiveTabKey={setActiveTabKey}
          setIsResumeViewing={setIsResumeViewing}
          handleSendReminderNotification={handleSendReminderNotification}
          setProfileMatchResult={setProfileMatchResult}
          setSelectedApplication={setSelectedApplication}
          setUserProfile={setUserProfile}
        />
        <InterviewProgress
          interviewSessions={interviewSessions}
          interviewRounds={interviewRounds}
          setActiveTabKey={setActiveTabKey}
          jobPost={jobPost}
          profile={profile}
          setSelectedSession={setSelectedSession}
          jobApplication={jobApplication}
          handleMoveToAIAssessmentRound={handleMoveToAIAssessmentRound}
          handleRestartAIAssessmentRound={handleRestartAIAssessmentRound}
          handleSendReminderNotification={handleSendReminderNotification}
        />
      </div>
    </div>
  );
};

export default JobApplicationSummary;
